var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "#EEF4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.953 6.06207C12.2723 5.10462 6.79462 15.4358 12.07 22.3789C13.9825 24.937 18.1269 30.4797 20.0054 33C21.8984 30.4663 26.0148 24.9482 27.9408 22.3802C32.6622 16.0654 28.8177 6.69792 20.953 6.06207ZM15.7779 16.0046C15.7986 13.6877 17.6855 11.8203 20.0054 11.8203C22.3252 11.8203 24.2122 13.6877 24.2329 16.0046C24.2121 18.3227 22.3252 20.1901 20.0054 20.1901C17.6855 20.1901 15.7985 18.3227 15.7779 16.0046Z",
    fill: "#444CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressPin);
export default __webpack_public_path__ + "static/media/address-pin.b410cc1e8425b1f0cdadcb72aa7719d8.svg";
export { ForwardRef as ReactComponent };